export const ru = {
    title: 'Добавление транзакции',
};
